<template>
    <Editor
        v-if="!isLoading"
        @close="closeImageEditor"
        module="patient"
        :file="file"
        :filename="filename"
        :name="name"
        :imageUrl="imageUrl"
        :entityId="entityId"
    />
</template>

<script>
/**
 * This is for dedicated annotation image editor - built to be used for Medical Note (Patient)
 */

import Editor from "@/components/commons/annotate.vue";

export default {
    components: {
        Editor
    },
    data() {
        return {
            file: null,
            filename: null,
            name: null,
            imageUrl: null,
            entityId: null,
            isLoading: true,
            refUrl: null,
            patientEncodedId: null
        };
    },
    mounted() {
        this.fetchDetails(this.$route.params.id);
    },
    methods: {
        async fetchDetails(id) {
            try {
                let res = await this.$http.get(
                    `${process.env.BARRAMUNDI}record/attachment/${id}`
                );

                let response = res.data.response;

                if (response.message && response.message.code === 200) {
                    let {
                        patient_id,
                        file_uri,
                        filename,
                        title,
                        patient,
                        reference_url
                    } = response.resource;

                    this.entityId = patient_id;
                    this.imageUrl = file_uri;
                    this.filename = filename;
                    this.file = title;
                    this.name = `${patient.name} (${patient.index})`;
                    this.isLoading = false;
                    this.refUrl = reference_url || null;
                    this.patientEncodedId = patient.encoded_id || patient.id;
                } else {
                    throw new Error("Error: Unable to load image");
                }
            } catch (e) {
                this._message(e.message, "danger");
            }
        },
        closeImageEditor() {
            if (this.refUrl) {
                window.location.href = `${process.env.CI_APPS}${this.refUrl}`;
            } else if (history.length > 2) {
                history.back();
            } else {
                this.$router.push({
                    name: "patient_profile",
                    params: {
                        id: this.patientEncodedId
                    }
                });
            }
        }
    }
};
</script>
